import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthService, User } from '@lib/core';
import { Observable, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthResolver implements Resolve<Observable<User | null>> {
  constructor(private authService: AuthService) {
    this.authService.check();
  }

  resolve(): Observable<any> {
    return this.authService.authenticated$.pipe(
      take(1),
      switchMap((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          return of(null);
        }

        return this.authService.getUser();
      }),
    );
  }
}
